<template>

    <table class="table is-fullwidth" v-if="orderReceipts.length">
      <thead>
        <tr>
          <th>Produto</th>
          <th v-for="packingToFill in packingsToFill" :key="packingToFill.id">
            {{ packingToFill.size | packingSize }}
          </th>
          <th>Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(orderReceipt, index) in orderReceipts">
          <td>
            <AutocompleteReceipt
              @setReceiptSelected="setReceiptSelected"
              :item="orderReceipt"
            ></AutocompleteReceipt>
          </td>
          <td v-for="pack in orderReceipt.orderPackings" :key="pack.id">
            <b-input type="number" v-model="pack.quantity"></b-input>
          </td>
          <td class="options">
            <a class="option" @click="removeItem(index)">Remover</a>
          </td>
        </tr>
      </tbody>
    </table>

</template>

<script>
import { mapState } from "vuex";
import AutocompleteReceipt from "./AutocompleteReceipt";

export default {
  name: "OrderReceiptComponent",
  components: { AutocompleteReceipt },
  computed: {
    ...mapState({ packings: state => state.packing.packings })
  },
  data: function() {
    return {
      receiptSearchText: "",
      receiptsList: [],
      selectedReceipt: {},
      isFetching: false,
      packingsToFill: [],
      orderReceipts: this.item
    };
  },
  props: ["item"],
  methods: {
    setReceiptSelected(item) {
      let selectedIndex = null;
      this.orderReceipts.forEach((orderReceipt, index) => {
        if (orderReceipt.id === item.id) {
          selectedIndex = index;
        }
      });
      if (selectedIndex != null) {
        this.$set(this.orderReceipts, selectedIndex, item);
      }
    },
    removeItem(index) {
      this.$delete(this.orderReceipts, index);
    },
    preparePackages() {
      //Prepare labels of packages size columns
      this.packings.forEach(item => {
        this.packingsToFill.push({
          id: item.id,
          quantity: 0,
          size: item.size
        });
      });
    }
  },
  mounted() {
    this.preparePackages();
  }
};
</script>

<style lang="scss" scoped>
.table-holder {
  &.orderReceiptTable {
    max-height: 300px;
    margin-bottom: 25px;
  }
}
tr{
  td:not(:first-child){
    width: 100px;
  }
}
</style>
